import { useRef, useEffect, useState } from "react"
import Layout from '../../Layout'
import Slider from "components/Promotion/SliderTop"
import CampaignCountdown from "components/Promotion/CampaignCountdown"
import { getProductListPromotion, PromotionItem } from "../../api/Promotion"
import { fetchFlashSales, FlashSaleItem } from "api/FlashSale"
import { API_URL } from "env"

export default function Promotion() {
    const [promotions, setPromotions] = useState<PromotionItem[]>([])
    const [flashSales, setFlashSales] = useState<FlashSaleItem[]>([])

    useEffect(() => {
        const fetchData = async () => {
            try {
                const [promoRes, flashRes] = await Promise.all([
                    getProductListPromotion(1, 10),
                    fetchFlashSales(1, 10)
                ])

                if (promoRes?.status) {
                    setPromotions(promoRes.data.items)
                }
                if (flashRes?.status) {
                    setFlashSales(flashRes.data.items)
                }
            } catch (error) {
                console.error("Error fetching data:", error)
            }
        }
        fetchData()
    }, [])

    return (
        <Layout>
            <div className="styles_container__ySmzO MuiBox-root css-0">
                <div className="styles_wrapper_breadcrums__FOYxY">
                    <nav className="MuiTypography-root MuiBreadcrumbs-root MuiTypography-body1 MuiTypography-colorTextSecondary" aria-label="breadcrumb">
                        <ol className="MuiBreadcrumbs-ol">
                            <li className="MuiBreadcrumbs-li">
                                <a className="styles_item_breadcrumb__eYGFd" href="/">Trang chủ</a>
                            </li>
                            <li aria-hidden="true" className="MuiBreadcrumbs-separator" ins-init-condition="#Lk11aUJyZWFkY3J1bWJzLW9sIGxpOm5vdCg6Zmlyc3Qp">
                                <svg className="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall" focusable="false" viewBox="0 0 24 24" aria-hidden="true">
                                    <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"></path>
                                </svg>
                            </li>
                            <li className="MuiBreadcrumbs-li" ins-init-condition="#Lk11aUJyZWFkY3J1bWJzLW9sIGxpOm5vdCg6Zmlyc3Qp">
                                <span className="styles_item_breadcrumb__eYGFd styles_last_breadcrumb__c7IQm">Khuyến mãi</span>
                            </li>
                        </ol>
                    </nav>
                </div>
                <Slider />

                {/* Flash Sales first */}
                {flashSales.map((item) => (
                    <CampaignCountdown
                        key={`flash-${item.id}`}
                        title={item.name}
                        startTime={item.start_time}
                        endTime={item.end_time}
                        icon={item.avatar ? (item.avatar.startsWith('http') ? item.avatar : `${API_URL}/${item.avatar}`) : undefined}
                        products={item.promotion_flash_sale_product.map(p => ({
                            promotion_id: p.promotion_flash_sale_id,
                            product_id: p.product_id,
                            percent: p.percent,
                            product: {
                                ...p.product,
                                is_active: p.product.is_active === 1,
                                is_highlight: p.product.is_highlight === 1,
                                is_stock: p.product.is_stock === 1
                            }
                        }))}
                    />
                ))}

                {/* Ordinary Promotions */}
                {promotions.map((item) => (
                    <CampaignCountdown
                        key={`promo-${item.id}`}
                        title={item.name}
                        startTime={item.start_date}
                        endTime={item.end_date}
                        icon={item.avatar ? (item.avatar.startsWith('http') ? item.avatar : `${API_URL}/${item.avatar}`) : undefined}
                        products={item.promotion_product}
                    />
                ))}
            </div>
        </Layout>
    )
}
